import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { DescriptionField, If } from "components/support";

import _ from "lodash";

class CustomerGeneralInfo extends Component {
  handleMask(identification) {
    if (!!identification) {
      if (identification.length === 11) {
        return [
          /\d/,
          /\d/,
          /\d/,
          ".",
          /\d/,
          /\d/,
          /\d/,
          ".",
          /\d/,
          /\d/,
          /\d/,
          "-",
          /\d/,
          /\d/
        ];
      } else if (identification.length === 14) {
        return [
          /\d/,
          /\d/,
          ".",
          /\d/,
          /\d/,
          /\d/,
          ".",
          /\d/,
          /\d/,
          /\d/,
          "/",
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          "-",
          /\d/,
          /\d/
        ];
      } else {
        return;
      }
    }
  }

  render() {
    const { customer, fields } = this.props;

    return (
      <div className="grid-container">
        <Row>
          <If test={_.findIndex(fields, { show: false, key: "name" }) === -1}>
            <Col xs={12} sm={6}>
              <DescriptionField label="Nome" value={customer.name} />
            </Col>
          </If>

          <If test={_.findIndex(fields, { show: false, key: "email" }) === -1}>
            <Col xs={12} sm={6}>
              <DescriptionField label="Email" value={customer.email} />
            </Col>
          </If>

          <If
            test={
              _.findIndex(fields, { show: false, key: "identification" }) === -1
            }
          >
            <Col xs={12} sm={12} lg={6}>
              <DescriptionField
                label="Identificação"
                value={customer.identification}
                mask={this.handleMask(customer.identification)}
              />
            </Col>
          </If>

          <If
            test={
              _.findIndex(fields, { show: false, key: "birth_date" }) === -1
            }
          >
            <Col xs={12} lg={3}>
              <DescriptionField
                disabled
                label="Data de Nascimento"
                value={customer.birth_date}
              />
            </Col>
          </If>

          <If test={_.findIndex(fields, { show: false, key: "phone" }) === -1}>
            <Col xs={12} lg={3}>
              <DescriptionField
                label="Telefone"
                value={(customer.phone || "").replace(/\D/g, "")}
                mask={[
                  "(",
                  /\d/,
                  /\d/,
                  ")",
                  " ",
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  "-",
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/
                ]}
              />
            </Col>
          </If>

          <If test={_.findIndex(fields, { show: false, key: "notes" }) === -1}>
            <Col xs={12}>
              <DescriptionField
                multiLine={true}
                label="Observações"
                value={customer.notes}
              />
            </Col>
          </If>
        </Row>
      </div>
    );
  }
}

export default CustomerGeneralInfo;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/view/general-info/index.jsx